import { render, staticRenderFns } from "./choose-seats.vue?vue&type=template&id=50646efa"
import script from "./choose-seats.vue?vue&type=script&lang=js"
export * from "./choose-seats.vue?vue&type=script&lang=js"
import style0 from "./choose-seats.vue?vue&type=style&index=0&id=50646efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports